import { Extension, SvgIconComponent } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import React from "react"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",

      width: "100%",
    },
    noResultsTypography: {
      marginTop: 24,
      ...theme.fonts.lato400,
      fontSize: 16,
    },
    noResultsPuzzlesContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      marginTop: 16,
      fontSize: 21.5,

      "& > *": {
        margin: theme.spacing(1),
      },

      "& > :nth-child(1)": {
        color: theme.palette.primary.main,
      },
      "& > :nth-child(2)": {
        color: theme.palette.primary.light,
        transform: "rotate(90deg)",
      },
      "& > :nth-child(3)": {
        color: theme.palette.primary.lighter,
      },
    },
  })
)

interface NoResultsFoundFallbackProps {
  CustomIcon?: SvgIconComponent
  customText?: string
}

/**
 * @deprecated use `EmptyStateFallback` instead
 */
export const NoResultsFoundFallback = (props: NoResultsFoundFallbackProps) => {
  const { CustomIcon = Extension, customText = "No results matching your criteria" } = props
  const { classes } = useStyles()
  return (
    <Box className={classes.container}>
      <Typography className={classes.noResultsTypography}>{customText}</Typography>
      <Box className={classes.noResultsPuzzlesContainer}>
        <CustomIcon color="inherit" fontSize="inherit" />
        <CustomIcon color="inherit" fontSize="inherit" />
        <CustomIcon color="inherit" fontSize="inherit" />
      </Box>
    </Box>
  )
}
